/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of GameTimeFootage Inc.
 #*
 #* Copyright NextPro 2018. All Rights Reserved.
 #*
 #*===================================================================
 */

import { CoachActionService } from './coach-action.service';
import { DomService } from './dom.service';
import { ScriptLoaderService } from './script-loader.service';
import { VideoPlayerService } from './video-player.service';

export * from './assets.service';
export * from './braintree.service';
export * from './breakdown.service';
export * from './channels.service';
export * from './clubs.service';
export * from './coach-action.service';
export * from './coupons.service';
export * from './date-formatter.service';
export * from './dom.service';
export * from './emails.service';
export * from './events.service';
export * from './http-helpers.service';
export * from './error-handler.service';
export * from './form-helpers.service';
export * from './games.service';
export * from './google-analytics.service';
export * from './invite.service';
export * from './loading-bar.service';
export * from './modal.service';
export * from './notifications.service';
export * from './native-dialog.service';
export * from './purchase.service';
export * from './signup.service';
export * from './sms.service';
export * from './script-loader.service';
export * from './sports.service';
export * from './storage.service';
export * from './toastr-translations-notification.service';
export * from './transcoder.service';
export * from './upload.service';
export * from './user-commitment.service';
export * from './user-data.service';
export * from './user.service';
export * from './user-new-videos.service';
export * from './user-events.service';
export * from './utils.service';
export * from './validators.service';
export * from './video.service';
export * from './video-player.service';
export * from './websockets.service';

export const services: any[] = [CoachActionService, DomService, ScriptLoaderService, VideoPlayerService];
